/**
 * Whether a saved recipe belongs in the library.
 *
 * A roundup clipped with the Chrome extension lands as a batch of
 * `pendingReview` recipes, and a household member's saves are shared with the
 * whole household. Without this, a partner would find every recipe of a
 * 27-recipe roundup in their library before anyone had looked at them, and the
 * ones turned down on the review screen would stay there for good. A recipe
 * saved on its own carries no review status and is shared at once.
 */
export const isInLibrary = (recipe: { reviewStatus?: string | null }): boolean =>
  recipe.reviewStatus !== 'pendingReview' && recipe.reviewStatus !== 'rejected';
